import { EstateDesignType } from "@1games-ru/region-shared/dist/enums/estate/estate";
import EstateDesignContainer from "@/domains/estate/containers/tablet/tabs/design/EstateDesignContainer";

export default function EstateDesignFurnitureContainer({ onClose }: { onClose: () => void }) {
  return <EstateDesignContainer type={EstateDesignType.Furniture} onClose={onClose} />;
}
